import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ProductSearchPage } from '@spartacus/core';
import { ProductListComponentService, ProductScrollComponent, ViewConfig, ViewModes } from '@spartacus/storefront';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-uig-product-scroll',
    templateUrl: './uig-product-scroll.component.html',
    styleUrls: ['./uig-product-scroll.component.scss'],
    standalone: false
})
export class UigProductScrollComponent extends ProductScrollComponent {

}
